import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@store/store';
import ProgramType from 'src/types/programType';

export type ProgramState = {
  selectedProgram: ProgramType | null;
};

const initialState: ProgramState = {
  selectedProgram: ProgramType.AmazonFresh, // default as Amazon Fresh
};

export const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    updateProgram: (state, action: PayloadAction<ProgramType>) => {
      state.selectedProgram = action.payload;
    },
  },
});

export const { updateProgram } = programSlice.actions;

export const selectProgram = (state: RootState) => state.program.selectedProgram;
export default programSlice.reducer;
